import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa6";
import { PROXY } from "../lib/utils";

const View = ({ mutate, views, courseId }) => {
    const [hasViewed, setHasViewed] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (!hasViewed) {
                viewHandler();
                setHasViewed(true);
            }
        }, 5000); // Call viewHandler after 5 seconds

        return () => clearTimeout(timer); // Clear the timer on unmount or navigation
    }, [hasViewed, courseId]);

    const viewHandler = async () => {
        try {
            if (courseId) {
                await fetch(`${PROXY}/courses/view/${courseId}`, {
                    method: "PUT",
                });
                mutate();
            }

        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="flex justify-center items-center gap-3 shadow rounded-md px-1">
            <FaEye size={20} cursor={"pointer"} title="Views" color="#3B82F6" />
            <span className="text-md">{views}</span>
        </div>
    )
}

export default View